import script from "./DetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailView.vue?vue&type=script&setup=true&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=ee1f43c0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee1f43c0"]])

export default __exports__